<div  class="loading-indicator">
  <!-- <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner> -->
</div>
<div><button mat-raised-button color="primary" (click)="payonline()">Pay Online</button></div>

<div  class="container-fluid mt-4" style="margin-bottom: 130px!important; min-width: 950px">
  <form class="example-form" [formGroup]="form">
    <div class="row">
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="row">
          <div >
            <mat-tab-group  [selectedIndex]="selectedIndex" #tabs
              (selectedTabChange)="tabChanged($event)">
              <mat-tab label="Qualification">
                <app-qualificationtab [QualificationTab]="QualificationTab" [QualificationTypes]="qualificationTypes">
                </app-qualificationtab>
              </mat-tab>
              <mat-tab  label="Verification"
                disabled>
                <app-qualificationtab [QualificationTab]="QualificationTab" [IsReadonly]="true"
                  [QualificationTypes]="qualificationTypes">
                </app-qualificationtab>
              </mat-tab>
              <mat-tab  label="Physical Address">
                <app-addresstabs [AddressTab]="PhysicalAddressTab" [CountryTypes]="countryTypes"
                  [StateTypes]="stateTypes"></app-addresstabs>
              </mat-tab>
              <mat-tab  label="Mailing Address">
                <app-addresstabs [IsMailingAddressTab]="true" [AddressTab]="MailingAddressTab"
                  [CountryTypes]="countryTypes" [StateTypes]="stateTypes"></app-addresstabs>
              </mat-tab>
              <mat-tab  label="License">
                <app-licensetab [CountyTypes]="countyTypes" [CityTypes]="cityTypes" [LicenseTab]="LicenseTab">
                </app-licensetab>
              </mat-tab>
              <mat-tab  label="Confirmation">
                <app-confirmationtab [QualificationTypes]="qualificationTypes" [CountyTypes]="countyTypes"
                  [CityTypes]="cityTypes" [StateTypes]="stateTypes" [ParentForm]="form"
                  [ConfirmationTab]="ConfirmationTab"></app-confirmationtab>
              </mat-tab>
              <mat-tab *ngIf="signatureTabApplies.includes(data?.exemptionRequestType?.code)" label="Signature">
                <app-signaturetab [SignatureTab]="SignatureTab"></app-signaturetab>
              </mat-tab>
              <mat-tab  label="Payment">
                <app-paymenttab [ParentForm]="form" [CityTypes]="cityTypes" [StateTypes]="stateTypes"
                  [OnlinePayment]="fisPaymentData" [PaymentTypes]="paymentTypes" [PaymentTab]="PaymentTab">
                </app-paymenttab>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-4">
            <button *ngIf="selectedIndex > 0"  mat-raised-button 
              style="margin-left: '30px'; border-radius: 5px; background-color: '#e7e3e3'; color: 'black';"
              (click)="previousStep()">Back</button>
          </div>
          <div class="col-4">
            <div *ngIf="!canSave"><button mat-raised-button color="primary" (click)="Continue()">Continue</button></div>
            <div *ngIf="canSave"><button mat-raised-button color="primary" (click)="saveAndContinue()">Save & Continue</button></div>
          </div>
          <div class="col-4"  fxFlex fxLayoutAlign="end start">
            <button mat-raised-button style="border-radius: 5px; background-color: '#e7e3e3'; color: 'black'; margin-right: 100px;"
              (click)="onCancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
